import keymirror from "../utils/keymirror";

export const CorrectionConstants = keymirror(
    {
        NEW_CORRECTION: null,
        UPDATE_CORRECTION: null,
        SUBMIT_CORRECTION: null,
        SUBMIT_CORRECTION_SUCCESS: null,
        SUBMIT_CORRECTION_FAILURE: null,
        CLOSE_CORRECTION: null,

        TOGGLE_CORRECTION_REACTION: null,
        TOGGLE_CORRECTION_REACTION_SUCCESS: null,
        TOGGLE_CORRECTION_REACTION_FAILURE: null,

        SUBMIT_COMMENT: null,
        SUBMIT_COMMENT_SUCCESS: null,
        SUBMIT_COMMENT_FAILURE: null,

        EDIT_CORRECTION: null,
        EDIT_CORRECTION_SUCCESS: null,
        EDIT_CORRECTION_FAILURE: null,

        DELETE_CORRECTION: null,
        DELETE_CORRECTION_SUCCESS: null,
        DELETE_CORRECTION_FAILURE: null,

        REPORT_CORRECTION: null,
        REPORT_CORRECTION_SUCCESS: null,
        REPORT_CORRECTION_FAILURE: null,

        COPY_LINK: null
    },
    "correction"
);



// WEBPACK FOOTER //
// ./src/constants/correction.constants.js